(() => {
  let savedMobileMarkup = null;
  let savedDesktopMarkup = null;
  const footer = document.querySelector(".js-footer");

  // This function is there for SEO purposes. It removes duplicate headings in the footer by keeping only the appropriate markup in the DOM.
  const toggleResponsiveMarkup = () => {
    const mobileMarkup = document.querySelector(".js-footer-mobile");
    const desktopMarkup = document.querySelector(".js-footer-desktop");

    if (window.innerWidth <= 1024) {
      if (desktopMarkup) {
        savedDesktopMarkup = desktopMarkup;
        desktopMarkup.remove();
      }

      if (!mobileMarkup && savedMobileMarkup) {
        document.body.appendChild(savedMobileMarkup);
        savedMobileMarkup = null;
      }
    } else {
      if (mobileMarkup) {
        savedMobileMarkup = mobileMarkup;
        mobileMarkup.remove();
      }

      if (!desktopMarkup && savedDesktopMarkup) {
        footer.appendChild(savedDesktopMarkup);
        savedDesktopMarkup = null;
      }
    }
  };

  const init = () => {
    toggleResponsiveMarkup();

    window.addEventListener("resize", toggleResponsiveMarkup);
  };

  init();
})();
